<template>
  <div class="hotel-page">
    <!-- 主內容 -->
    <!-- 主圖片區 (輪播圖) -->
    <section id="hero" class="carousel-container">
      <div class="carousel">
        <div
          class="carousel-slide"
          v-for="(image, index) in images"
          :key="index"
          :class="{ active: currentSlide === index }"
        >
          <img :src="image" alt="輪播圖圖片" />
        </div>
      </div>
      <!-- 底部選擇按鈕 -->
      <div class="carousel-indicators">
        <button
          v-for="(image, index) in images"
          :key="index"
          @click="goToSlide(index)"
          :class="{ active: currentSlide === index }"
        ></button>
      </div>
    </section>
    <main>
      <section class="room-title">
        <h2>Dawnwood Suite</h2>
        <h3>木光晨曦套房</h3>
      </section>
      <!-- 房型介紹 -->
      <section class="room-row">
        <!-- 房型介紹 -->
        <div class="room-column">
          <h3>房型介紹</h3>
          <p>
            此房型融合現代與自然風格，以溫潤木質與柔和燈光營造溫馨氛圍。窗外綠意盎然，仿佛置身於森林之中，為客人帶來身心放鬆的住宿體驗。
            確保旅客能享受最愜意的住宿環境。
            <br/>※ 各房型格局不盡相同，圖片僅供參考，依實際入住房型為主
          </p>
        </div>

        <!-- 詳細資訊 -->
        <div class="room-column">
          <h3>詳細資訊</h3>
          <p>入住人數：2 人</p>
          <p>房間坪數：8-10 坪（26-33 sq.m.）</p>
          <p>房間床型：一大床 / 兩小床</p>
        </div>

        <!-- 定價 -->
        <div class="room-column">
          <h3>定價</h3>
          <p>NT$3,800 元</p>
          <button class="reserve-btn" @click="navigateToBooking
">立即預定</button>
        </div>
      </section>

      <!-- 衛浴設備 -->
      <section class="room-facilities">
        <h3>衛浴設備</h3>
        <ul>
          <li><i class="fa-solid fa-hot-tub-person"></i> 溫泉</li>
          <li><i class="fas fa-toilet"></i>免治馬桶</li>
          <li><i class="fa-solid fa-pump-soap"></i> 沐浴用品</li>
          <li><i class="fa-solid fa-soap"></i> 洗臉皂</li>
        </ul>
      </section>

      <!-- 客房設施 -->
      <section class="room-facilities">
        <h3>客房設施</h3>
        <ul>
          <li><i class="fas fa-bed"></i> 大床</li>
          <li><i class="fas fa-tv"></i> 液晶電視</li>
          <li><i class="fas fa-wifi"></i> 免費無線上網</li>
          <li><i class="fa-solid fa-martini-glass-citrus"></i> 迷你吧</li>
          <li><i class="fa-solid fa-wine-bottle"></i> 紅酒吧</li>
          <li><i class="fas fa-mug-hot"></i> 咖啡機</li>
          <li><i class="fas fa-water"></i> 瓶裝水</li>
          <li><i class="fa-solid fa-spa"></i> spa服務<br />(7:00 - 11:00)</li>
          <li>
            <i class="fa-solid fa-bell-concierge"></i>
            客房餐飲服務<br />(06:00-23:30)
          </li>
        </ul>
      </section>

      <!-- 訂房需知 -->
      <section class="booking-info">
        <h3>訂房須知</h3>
        <ul>
          <li>飯店入住時間為下午三點後，退房時間為中午十二點前。</li>
          <li>提前入住或延後退房需另收取相關費用，並以飯店回覆為主。</li>
          <li>本飯店設有停車場，請參考飯店附近停車場資訊。</li>
          <li>
            為確保所有旅客之住宿品質，於晚間 10
            點過後請勿大聲喧嘩、吵鬧，敬請配合。
          </li>
          <li>
            本飯店依據菸害防治法全館禁菸，若有相關行為，飯店有權收取新台幣 2,000
            元至 10,000 元不等之清潔費用。
          </li>
          <li>
            本飯店視入住房型另提供加床服務，如有加床需求,請直接與飯店人員接洽-
            加床費用：1,500 元(需另加一成服務費)
          </li>
          <li>可免費提供嬰兒床、嬰兒澡盆，數量有限，請提早預約保留。</li>
          <li>
            未滿 18
            歲的旅客需有成人陪同或提供家長同意書，並附上親筆簽名方可入住。
          </li>
          <li>
            為確保其他住客權益，如於飯店內賭博、酗酒或從事任何違法活動，本飯店有權拒絕入住，並報警處理。
          </li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "RoomDetail",
  data() {
    return {
      currentSlide: 0, // 當前顯示的圖片索引
      images: [], // 存放所有的圖片路徑
      autoSlideInterval: null, // 自動播放的定時器
    };
  },
  methods: {

    goToBooking() {
    this.$router.push('/booking'); // 使用 Vue Router 導航到 /booking
  },

  navigateToBooking() {
      this.$router.push("/booking").catch(err => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err); // 僅記錄非重複導航的錯誤
        }
      });
    },

    // 動態加載圖片
    loadImages() {
      const context = require.context(
        "@/assets/picture/RoomImage",
        false,
        /\.(png|jpe?g|gif|svg)$/
      );
      this.images = context.keys().map((key) => context(key)); // 將圖片賦值給 images
    },
    // 切換到特定的幻燈片
    goToSlide(index) {
      this.currentSlide = index;
    },
    // 顯示下一張幻燈片
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
    },
    // 啟動自動播放
    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 3500); // 每 3.5 秒切換一次
    },
    // 停止自動播放
    stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    },
  },
  mounted() {
    this.loadImages(); // 加載圖片
    this.startAutoSlide(); // 啟動自動播放
  },
  beforeDestroy() {
    this.stopAutoSlide(); // 停止自動播放
  },
};
</script>

<style src="@/assets/css/roomdetail.css" scoped></style>
